import { LinkableEntityType } from '@api';
import { Anchor } from '@common';

type ArtistAnchorPropsType = { artist: LinkableEntityType };

export const ArtistAnchor: React.FC<ArtistAnchorPropsType> = ({ artist }) => {
  return (
    <Anchor key={artist.id} to={`/artists/$id`} params={{ id: artist.id }}>
      {artist.name}
    </Anchor>
  );
};
